import useIsNarrowerThan from './useIsNarrowerThan';
import useIsWiderThan from './useIsWiderThan';
/**
 * React Hook that returns the how many search columns to show
 * based on the window size
 *
 * @returns number - indicating how many categories to show
 */

const useGetSearchColumns = () => {
    const widerThan820 = useIsWiderThan(820);
    const widerThan767 = useIsWiderThan(767);
    const narrowerThan550 = useIsNarrowerThan(550);

    let columns = narrowerThan550 ? 2 : 3;
    columns = widerThan767 ? 2 : columns;

    return widerThan820 ? 3 : columns;
};

export default useGetSearchColumns;
